/**
 * Comparison Dialog Component
 * Displays PRS comparison in a modal dialog (read-only)
 *
 * Updated: Nov 12, 2025 - Now uses PRSComparisonViewer for structured JSON display
 */

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import {Close as CloseIcon} from '@mui/icons-material';
import {PRSComparisonViewer} from './PRSComparisonViewer';

interface ComparisonDialogProps {
  open: boolean;
  onClose: () => void;
  comparisonData: any; // Full comparison response from API
  baseVersion?: string;
  newVersion?: string;
}

export const ComparisonDialog: React.FC<ComparisonDialogProps> = ({
  open,
  onClose,
  comparisonData,
  baseVersion,
  newVersion,
}) => {
  if (!comparisonData) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {height: '90vh'},
      }}
    >
      <DialogTitle>
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <Typography variant="h6">
            PRS Comparison: {baseVersion} → {newVersion}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent dividers sx={{overflow: 'auto', p: 3}}>
        <PRSComparisonViewer comparisonData={comparisonData} />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
